/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const QuantityUsageType = {
    Setup: 'Setup',
    Evaluation: 'Evaluation',
    All: 'All'
} as const;
export type QuantityUsageType = typeof QuantityUsageType[keyof typeof QuantityUsageType];


export function QuantityUsageTypeFromJSON(json: any): QuantityUsageType {
    return QuantityUsageTypeFromJSONTyped(json, false);
}

export function QuantityUsageTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuantityUsageType {
    return json as QuantityUsageType;
}

export function QuantityUsageTypeToJSON(value?: QuantityUsageType | null): any {
    return value as any;
}

/**
 * Check if a given object implements the QuantityUsageType interface.
 */
 export function instanceOfQuantityUsageType(value: any): value is QuantityUsageType {
    return Object.values(QuantityUsageType).includes(value)
}

